import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from "@angular/forms";
import { AuthService } from "../core/service/auth.service";
import { Router } from "@angular/router";
import {
  catchError,
  exhaustMap,
  finalize,
  map,
  mergeMap,
  switchMap,
  first
} from "rxjs/operators";
import { of } from "rxjs";
import { ToastrManager } from "ng6-toastr-notifications";
import { IUser } from "../core/model/User.model";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    public toastr: ToastrManager
  ) {}

  ngOnInit() {
    this.createLoginForm();
  }

  createLoginForm() {
    this.loginForm = new FormGroup({
      email: new FormControl("", {
        validators: [Validators.required, Validators.email]
      }),
      password: new FormControl("", {
        validators: [Validators.required]
      })
    });
  }

  loginSubmit() {
    const email = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.loading = true;
    this.authService
      .logInAndGetUserProfile(email, password)
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
        catchError(err => {
          this.toastr.errorToastr("Credenziali invalide");
          return of([]);
        })
      )
      .subscribe(user => {
        if (user !== []) {
          const userProfile = user as IUser;
          if (userProfile.isStaff) {
            this.router.navigate(["/"]);
          } else {
            this.router.navigate(["/customer"]);
          }
        }
      });
  }
}
